// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___1-WUJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Tabs/Editor/styles.css
// module id = 964
// module chunks = 0